import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ProductList } from '../components/ProductList';
import { useTranslation } from '../i18n';

interface ProductsPageProps {
  token: string | null;
  userId: number | null;
  isVerified: boolean;
  onLogin: (accessToken: string, refreshToken: string) => void;
  setError: (e: string) => void;
}

export const ProductsPage: React.FC<ProductsPageProps> = ({ token, userId, isVerified, onLogin, setError }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentMessage, setPaymentMessage] = useState('');

  useEffect(() => {
    const payment = searchParams.get('payment');
    if (payment === 'success') {
      navigate('/orders?payment=success', { replace: true });
    } else if (payment === 'cancelled') {
      setPaymentMessage(t('payment.cancelled'));
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate, t]);

  return (
    <>
      {paymentMessage && (
        <div className="alert alert-warning">
          {paymentMessage}
          <button className="dismiss" onClick={() => setPaymentMessage('')}>&times;</button>
        </div>
      )}
      <ProductList token={token} userId={userId} isVerified={isVerified} onLogin={onLogin} setError={setError} />
    </>
  );
};
